import React, { useState } from "react";
import {
  Title,
  Text,
  Stack,
  Button,
  Grid,
  Card,
  Badge,
  Switch,
  Select,
  Box,
  Container,
  Center,
  Flex,
} from "@mantine/core";

import { COLORS } from "../utils";

export function SettingsPage() {
  return (
    <Center h={"100vh"}>
      <Text fw={600}>Settings Page Coming Soon...</Text>
    </Center>
  );
}
